export default __webpack_public_path__ + "static/media/Jenny_Timur-682_websize_tn.a4c44c7f.jpg";